import { Controller } from "@hotwired/stimulus"
import { ModalLoaders } from "../utils/modal_loader"
import { confirmBeforeSubmit } from "../utils/form_confirmation"

export default class extends Controller {
  static targets = []

  /**
   * フォーム送信前に確認ダイアログを表示します。
   * @param {Event} event - フォーム送信イベント
   * @returns {boolean} 確認でキャンセルされた場合はfalseを返します。
   */
  confirmBeforeSubmit(event) {
    return confirmBeforeSubmit(event, {
      submitButtonTarget: 'items-target="submitButton"'
    })
  }

  /**
   * StimulusコントローラーがDOMに接続されたときに呼び出されます。
   * 編集モーダルのローダーを初期化します。
   */
  connect() {
    // 商品編集モーダルのローダーを初期化
    this.modalLoader = ModalLoaders.createEditModal('item')

    // 新規モーダルの初期HTMLを保存（タブ切替でitem_typeが変わるため毎回更新）
    this.saveNewModalInitialHtml()

    // Turbo Frame更新後にも初期HTMLを更新（タブ切替対応）
    this._turboFrameLoadHandler = (event) => {
      if (event.target.id === 'item_table') {
        // item_tableフレームが更新されたら初期HTMLを更新
        this.saveNewModalInitialHtml()
      }
    }
    document.addEventListener('turbo:frame-load', this._turboFrameLoadHandler)
  }

  /**
   * StimulusコントローラーがDOMから切断されたときに呼び出されます。
   */
  disconnect() {
    if (this._turboFrameLoadHandler) {
      document.removeEventListener('turbo:frame-load', this._turboFrameLoadHandler)
    }
  }

  /**
   * 新規モーダルの初期HTMLを保存します。
   * 商品タイプ（商品/セット商品/資材）が変わるたびに更新が必要です。
   */
  saveNewModalInitialHtml() {
    const frame = document.getElementById('new_item_modal_frame')
    if (frame) {
      // モーダルが開いていない状態のHTMLを保存
      const modal = frame.querySelector('dialog')
      if (!modal || !modal.open) {
        this._newModalInitialHtml = frame.innerHTML
      }
    }
  }

  /**
   * 新規登録モーダルを閉じてフォームをリセットします。
   * バリデーションエラー後も初期状態に戻します。
   */
  closeNewModal() {
    const modal = document.getElementById('new_item_modal')
    if (!modal) return

    // モーダルを閉じる
    modal.close?.() || modal.removeAttribute('open')

    // アニメーション完了後にHTMLを復元
    const resetModal = () => {
      const frame = document.getElementById('new_item_modal_frame')
      if (frame && this._newModalInitialHtml) {
        frame.innerHTML = this._newModalInitialHtml
      } else if (modal) {
        // フォールバック: 単純なリセット
        const form = modal.querySelector('form')
        if (form) {
          form.reset()
          // エラーメッセージを削除
          form.querySelectorAll('.field_with_errors, .text-error, .alert-error').forEach(el => el.remove())
        }
      }
    }

    // アニメーション完了を待ってからリセット（DaisyUIのモーダルアニメーションは約200ms）
    setTimeout(resetModal, 300)
  }

  /**
   * 編集モーダルを開き、指定された商品の編集フォームを読み込みます。
   * @param {Event} event - クリックイベント
   */
  openEditModal(event) {
    // データ属性からitemIdを取得
    const itemId = event.currentTarget.dataset.itemId

    if (!itemId) {
      return
    }

    // モーダルローダーを使用してデータを読み込む
    this.modalLoader.loadWithTurboStream(`/items/${itemId}/edit`)
      .catch(error => {
        console.error('Item edit modal error:', error)
      })
  }
}
